import { render, staticRenderFns } from "./Comingsoon.vue?vue&type=template&id=09e7c13d&scoped=true&"
import script from "./Comingsoon.vue?vue&type=script&lang=js&"
export * from "./Comingsoon.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon.vue?vue&type=style&index=0&id=09e7c13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7c13d",
  null
  
)

export default component.exports